import * as React from "react";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import ParcelLogo from "../ParcelLogo";
const useStyles = makeStyles(({
  breakpoints,
  typography
}) => ({
  wrapper: {
    marginLeft: "auto",
    marginRight: "auto"
  },
  contentWrapper: {
    padding: `${typography.pxToRem(60)} ${typography.pxToRem(100)} ${typography.pxToRem(30)}`,
    [breakpoints.down("xs")]: {
      padding: `${typography.pxToRem(55)} ${typography.pxToRem(40)} ${typography.pxToRem(30)}`
    }
  },
  card: {
    display: "flex",
    boxShadow: `0 ${typography.pxToRem(1)} ${typography.pxToRem(6)} 0 rgba(0, 0, 0, 0.16)`,
    position: "relative",
    [breakpoints.down("xs")]: {
      marginTop: typography.pxToRem(176)
    },
    [breakpoints.up("sm")]: {
      marginTop: typography.pxToRem(200)
    }
  },
  logoContainer: {
    position: "absolute",
    left: "50%",
    top: 0,
    transform: "translate(-50%, -50%)"
  }
}));

const ParcelInfo = ({
  logo,
  parcelNumber,
  children,
  contentWrapperClassName
}) => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement(Paper, {
    className: styles.card
  }, /*#__PURE__*/React.createElement(ParcelLogo, {
    image: logo,
    parcelNumber: parcelNumber,
    className: styles.logoContainer
  }), /*#__PURE__*/React.createElement(Grid, {
    className: clsx(styles.contentWrapper, contentWrapperClassName),
    container: true,
    direction: "column",
    align: "center"
  }, children));
};

export default ParcelInfo;